import { axiosAction } from '../../utils/axiosAction';
import { constructSearchObj, EvalResponse } from '../../utils/utils';
import {
  MENU_ITEM_TRANSLATIONS,
  MENU_ITEM_TRANSLATIONS_UPDATE,
  MENU_ITEMS_CREATE_PRODUCT_PROFILES,
  MENU_ITEMS_FETCH_PRODUCT_PROFILES,
  MENU_ITEMS_REMOVE_PRODUCT_PROFILES,
  MENU_ITEMS_UPDATE_PRODUCT_PROFILES,
} from '../action-types/menu-items-types';

const CATEGORIES_ITEMS_ENDPOINT = `${process.env.REACT_APP_ENDPOINT_PRODUCT_CATEGORIES}`;
const MENU_ITEM_ENDPOINT = `${process.env.REACT_APP_ENDPOINT_MENU_ITEM}`;
const MENU_ITEM_TRANSLATION_ENDPOINT =
  process.env.REACT_APP_ENDPOINT_MENU_ITEMS_TRANSLATIONS;

export const getMenuItemsHoldingProfiles =
  (searchObj, idPlatformItem, idProductGroup, idMenuItem) => async dispatch => {
    const endpoint = `${CATEGORIES_ITEMS_ENDPOINT}/${idPlatformItem}/product-groups/${idProductGroup}/menu-items/${idMenuItem}${constructSearchObj(
      searchObj,
    )}`;
    return axiosAction.get(
      endpoint,
      MENU_ITEMS_FETCH_PRODUCT_PROFILES,
      dispatch,
    );
  };
export const createMenuItemsHoldingProfiles =
  (idMenuItem, brand, body) => async dispatch => {
    const endpoint = `${MENU_ITEM_ENDPOINT}/${idMenuItem}/product-profiles?brand=${brand}`;
    return axiosAction.post(
      endpoint,
      MENU_ITEMS_CREATE_PRODUCT_PROFILES,
      dispatch,
      body,
    );
  };
export const updateMenuItemsHoldingProfiles =
  (idMenuItem, idProductProfile, brand, body) => async dispatch => {
    const endpoint = `${MENU_ITEM_ENDPOINT}/${idMenuItem}/product-profiles/${idProductProfile}?brand=${brand}`;
    const response: any = await axiosAction.put(
      endpoint,
      MENU_ITEMS_UPDATE_PRODUCT_PROFILES,
      dispatch,
      body,
    );

    EvalResponse(response);

    return response;
  };
export const removeMenuItemsHoldingProfiles =
  (idMenuItem, idProductProfile) => async dispatch => {
    return axiosAction.delete(
      `${MENU_ITEM_ENDPOINT}/${idMenuItem}/product-profiles/${idProductProfile}`,
      MENU_ITEMS_REMOVE_PRODUCT_PROFILES,
      dispatch,
    );
  };

export const getMenuItemTranslation = (menuItemId, brand) => async dispatch => {
  return axiosAction.get(
    `${MENU_ITEM_TRANSLATION_ENDPOINT}/${menuItemId}/translations?brand=${brand}`,
    MENU_ITEM_TRANSLATIONS,
    dispatch,
  );
};

export const UpdateMenuItemTranslation =
  (menuItemId, brand, translationsValues) => async dispatch => {
    return axiosAction.put(
      `${MENU_ITEM_TRANSLATION_ENDPOINT}/${menuItemId}/translations?brand=${brand}`,
      MENU_ITEM_TRANSLATIONS_UPDATE,
      dispatch,
      {
        translations: translationsValues,
      },
    );
  };
